import React from 'react';
import { observer } from 'mobx-react';
import { UserContainer } from 'services/User';
import { PageDrawer } from 'components/PageDrawer';
import { PageWrapper } from 'components/PageWrapper';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import ThirdPartyAuth from 'services/ThirdPartyAuth';

const Home = React.lazy(() => import('pages/Home'));
const Login = React.lazy(() => import('pages/Login'));
const Alerts = React.lazy(() => import('pages/Alerts'));
const Pixels = React.lazy(() => import('pages/Pixels'));

const ArticleRoutes = React.lazy(() => import('routes/ArticleRoutes'));
const InsightsRoutes = React.lazy(() => import('routes/InsightsRoutes'));
const CampaignRoutes = React.lazy(() => import('routes/CampaignsRoutes'));
const LeadFormsRoutes = React.lazy(() => import('routes/LeadFormsRoutes'));
const PublisherRoutes = React.lazy(() => import('routes/PublisherRoutes'));
const RulesRoutes = React.lazy(() => import('routes/RulesRoutes'));
const ExperimentsRoutes = React.lazy(() => import('routes/ExperimentsRoutes'));
const ArticleGroupsRoutes = React.lazy(() => import('routes/ArticleGroupsRoutes'));
const FacebookImportRoutes = React.lazy(() => import('routes/FacebookImportRoutes'));
const AccountsOverviewRoutes = React.lazy(() => import('routes/AccountsOverviewRoutes'));

const AppRouting: React.FC = () => {
  return (
    <Router>
      <Switch>
        <Route path="/login" component={Login} />
        <UserContainer>
          <ThirdPartyAuth>
            <PageWrapper width="100%">
              <PageDrawer>
                <Switch>
                  <Route path="/" exact component={Home} />
                  <Route path="/pixels" component={Pixels} />
                  <Route path="/alerts" component={Alerts} />
                  <Route path="/articles" component={ArticleRoutes} />
                  <Route path="/insights" component={InsightsRoutes} />
                  <Route path="/campaigns" component={CampaignRoutes} />
                  <Route path="/publishers" component={PublisherRoutes} />
                  <Route path="/rules" component={RulesRoutes} />
                  <Route path="/lead-forms" component={LeadFormsRoutes} />
                  <Route path="/experiments" component={ExperimentsRoutes} />
                  <Route path="/article_groups" component={ArticleGroupsRoutes} />
                  <Route path="/facebook_imports" component={FacebookImportRoutes} />
                  <Route path="/accounts-overview" component={AccountsOverviewRoutes} />
                  <Route component={Home} />
                </Switch>
              </PageDrawer>
            </PageWrapper>
          </ThirdPartyAuth>
        </UserContainer>
      </Switch>
    </Router>
  );
};

export default observer(AppRouting);
